// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import WeiboCircleFilledSvg from "@ant-design/icons-svg/es/asn/WeiboCircleFilled";
import AntdIcon from '../components/AntdIcon';

var WeiboCircleFilled = function WeiboCircleFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: WeiboCircleFilledSvg
  }));
};

WeiboCircleFilled.displayName = 'WeiboCircleFilled';
export default React.forwardRef(WeiboCircleFilled);